export const offerRequestsTableConfig = {
  // Add translation keys to template when new columns are added here
  columns: [
    { prop: 'projectName', translationKey: 'project_name', flexGrow: 2, type: undefined },
    { prop: 'investorName', translationKey: 'investor_name', flexGrow: 2, type: undefined },
    { prop: 'email', translationKey: 'email', flexGrow: 2, type: undefined },
    { prop: 'mobilePhone', translationKey: 'mobilePhone', flexGrow: 2, type: undefined },
    { prop: 'eligibleForGridConnection', translationKey: 'eligible_for_grid_connection', flexGrow: 1, type: 'bool' },
    {
      prop: 'optimalPowerLessThanConnectedPower',
      translationKey: 'optimal_power_less_than_connected_power',
      flexGrow: 1,
      type: 'bool',
    },
    {
      prop: 'loanFinancingForSolarPlantDesired',
      translationKey: 'loan_financing_for_solar_plant_desired',
      flexGrow: 1,
      type: 'bool',
    },
    { prop: 'conceptualProjectNeeded', translationKey: 'conceptual_project_needed', flexGrow: 1, type: 'bool' },
  ],
};
